module.exports = __webpack_public_path__ + "img/friends_vs_logo.d2c906a2.webp";